// AppContext.js
import React, { createContext, useReducer, useState } from "react";

const AppContext = createContext();

// Define your initial state
const initialState = {
  searchQuery: "",
  selectedProvider: "All",
  selectedSort: "All",
};

// Create a reducer to handle state updates
const searchReducer = (state, action) => {
  switch (action.type) {
    case "UPDATE_SEARCH":
      return { ...state, searchQuery: action.payload };
    case "UPDATE_PROVIDER":
      return { ...state, selectedProvider: action.payload };
    case "UPDATE_SORT":
      return { ...state, selectedSort: action.payload };
    default:
      return state;
  }
};

const AppProvider = ({ children }) => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [prevSidebarOpen, setPrevSidebarOpen] = useState(false);
  const [isMobileScreen, setIsMobileScreen] = useState(false);
  const [isTabletScreen, setIsTabletScreen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [onClickFunctionNext, setOnClickFunctionNext] = useState(null);
  const [onClickFunctionPrev, setOnClickFunctionPrev] = useState(null);
  const [searchState, setSearchState] = useReducer(searchReducer, initialState);
  const [selectedOptionCashier, setSelectedOptionCashier] = useState("Deposit");
  const [isAttendanceModalOpen, setIsAttendanceModalOpen] = useState(false);
  const [cashierModal, setCashierModal] = useState({
    isOpen: false,
    view: null,
  });

  const updateMobileScreen = (option) => {
    setIsMobileScreen(option);
  };
  const updateTabletScreen = (option) => {
    setIsTabletScreen(option);
  };
  const updateCashierOption = (option) => {
    setSelectedOptionCashier(option);
  };
  const updateAttendanceModal = (option) => {
    setIsAttendanceModalOpen(Boolean(option));
  };
  const openCashierModal = (view = null) => {
    setCashierModal({
      isOpen: true,
      view: view || null,
    });
  };
  const closeCashierModal = () => {
    setCashierModal((current) => ({
      ...current,
      isOpen: false,
      view: null,
    }));
  };

  const updateSelectedOption = (option) => {
    setSelectedOption(option);
  };
  const updateSidebar = (option) => {
    setIsSidebarOpen(option);
  };
  const updatePrevSidebar = (option) => {
    setPrevSidebarOpen(option);
  };
  const toggleDropdown = (option) => {
    setOpenDropdown(option);
  };
  const updateLoggedIn = (option) => {
    setIsLoggedIn(option);
  };
  const updateOnClickFunctionNext = (option) => {
    setOnClickFunctionNext(option);
  };
  const updateOnClickFunctionPrev = (option) => {
    setOnClickFunctionPrev(option);
  };
  const updateProvider = (provider) => {
    setSearchState({ type: "UPDATE_PROVIDER", payload: provider });
  };
  const updateSort = (sort) => {
    setSearchState({ type: "UPDATE_SORT", payload: sort });
  };
  return (
    <AppContext.Provider
      value={{
        selectedOption,
        isSidebarOpen,
        openDropdown,
        isLoggedIn,
        onClickFunctionNext,
        onClickFunctionPrev,
        searchState,
        selectedOptionCashier,
        isAttendanceModalOpen,
        cashierModal,
        isMobileScreen,
        isTabletScreen,
        prevSidebarOpen,
        updatePrevSidebar,
        updateMobileScreen,
        updateTabletScreen,
        updateSelectedOption,
        updateSidebar,
        toggleDropdown,
        updateLoggedIn,
        updateOnClickFunctionNext,
        updateOnClickFunctionPrev,
        setSearchState,
        updateProvider,
        updateSort,
        updateCashierOption,
        updateAttendanceModal,
        openCashierModal,
        closeCashierModal,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export { AppContext, AppProvider };
